import { useEffect } from 'react';
import { useRouter } from '@/hooks/use-routing';
import { useCurrentUser } from '@/hooks/use-current-user-org';
import { LoadingSpinner } from '@sharpe/ui/components';

/**
 * Auth callback page for post-SSO-login processing.
 * Redirects to home once authenticated.
 */
export default function AuthCallbackPage() {
  const { sessionStatus, isLoading, isAuthenticated } = useCurrentUser();
  const router = useRouter();

  useEffect(() => {
    if (isLoading || sessionStatus === 'loading') return;

    if (!isAuthenticated) {
      router.push('/auth/signin');
      return;
    }

    router.push('/');
  }, [isAuthenticated, isLoading, sessionStatus, router]);

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <div className="mx-auto mb-4">
          <LoadingSpinner size="lg" />
        </div>
        <p className="text-sm text-foreground">Setting up your environment...</p>
      </div>
    </div>
  );
}
